import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tokens.css 字級 ramp 含非標準名 micro／md；未註冊時 twMerge 把它們歸入
// 顏色組，會吃掉同一次 cn() 裡的真顏色類名（實例：destructive Badge 加
// text-micro 後前景色類被丟棄，fg 退回 inherited——axe color-contrast 違規）。
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['micro', 'md'] }],
    },
  },
});

/** Tailwind class 合併。後者覆蓋前者的同類 utility，避免 class 順序造成的隨機結果。 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
